import { render, staticRenderFns } from "./ClientsScreen.vue?vue&type=template&id=1acbb42e&scoped=true"
import script from "./ClientsScreen.vue?vue&type=script&lang=js"
export * from "./ClientsScreen.vue?vue&type=script&lang=js"
import style0 from "./ClientsScreen.vue?vue&type=style&index=0&id=1acbb42e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acbb42e",
  null
  
)

export default component.exports